import { render, staticRenderFns } from "./IconGraduate.vue?vue&type=template&id=33e8bc08&"
import script from "./IconGraduate.vue?vue&type=script&lang=js&"
export * from "./IconGraduate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports